import React from "react";
import "../CSS/Footer.css";
import logoWhite from '../Images/medwell-logo-white.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <img src={logoWhite} alt="Medwell360 Logo" className="footer-logo" />
      </div>
      <nav className="footer-nav">
        <div className="footer-col">
          <span className="footer-link footer-heading">Our Solutions</span>
          <a href="/payer" className="footer-link">Payer</a>
          <a href="/revenue-cycle" className="footer-link">Revenue Cycle Management</a>
          <a href="/workers-comp" className="footer-link">Workers' Compensation</a>
          <a href="/life-sciences" className="footer-link">Life Sciences</a>
        </div>
        <div className="footer-col">
          <span className="footer-link footer-heading">Our Services</span>
          <a href="/coding-services" className="footer-link">Coding</a>
          <a href="/utilization-management" className="footer-link">Utilization Management</a>
          <a href="/bill-review" className="footer-link">Bill Review</a>
          <a href="/patient-care" className="footer-link">Patient Care</a>
          <a href="/absence-management" className="footer-link">Absence & Disability</a>
          <a href="/nursing-jobs" className="footer-link">U.S. Nursing Jobs</a>
        </div>
        <div className="footer-col footer-col-single footer-links-interactive">
          <a href="#" className="footer-link-interactive">Who We Are</a>
        </div>
        <div className="footer-col footer-col-single footer-links-interactive">
          <a href="/careers" className="footer-link-interactive">Careers</a>
        </div>
        <div className="footer-col footer-col-single footer-links-interactive">
          <a href="/contact-us" className="footer-link-interactive">Contact Us</a>
        </div>
      </nav>
    </footer>
  );
};

export default Footer; 